/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Media from 'react-media';
import Modal from 'shared/modals/Modal';
import Icon from 'shared/icons/IconComponent';

const NavMenu = ({ history, isCollapsed, setIsCollapsed }) => {
  const [modalShowing, setModalShowing] = useState(true);

  const handleToggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
    setModalShowing(!modalShowing);
  };

  const navItems = [
    {
      id: 'search',
      icon: 'search',
      label: 'Search',
      onClick: () => history.push('/search')
    },
    {
      id: 'print',
      icon: 'print',
      label: 'Print',
      onClick: () => history.push('/search?status=1')
    }
  ];
  
  const NavItem = ({ item, isButton = false }) => (
    <div 
      className={isButton ? `toggle-button ${isCollapsed ? item.id : 'hidden'}` : 'nav-item'} 
      onClick={item.onClick}
      style={{ cursor: 'pointer' }}
    >
      <Icon
        icon={item.icon}
        className={isButton ? "icon--font-medium caret-icon" : "nav-icon"}
        position='none'
      />
      {!isButton && <span>{item.label}</span>}
    </div>
  );
  
  return (
    <Media queries={{ small: '(max-width: 699px)', medium: '(min-width: 700px) and (max-width: 1199px)', large: '(min-width: 1200px)' }}>
      {(matches) => (
        <>
          {matches.small && (
            <Modal
              isOpen={modalShowing}
              handleClose={() => handleToggleSidebar()}
              containerStyle='large'
              className='search-page-modal'
            >
              <div className='modal-header'>
                <h5 className='modal-title' id='search-modal'>
                  Navigation
                </h5>
                <button className='button button--large button--close' onClick={() => handleToggleSidebar()} />
              </div>
              <section className='modal-body'>
                <div className='nav-menu-items'>
                  {navItems.map(item => (
                    <NavItem key={item.id} item={item} />
                  ))}
                </div>
              </section>
              <section className='modal-footer toolbar toolbar--xxs'>
                <button
                  id='close-nav-modal-button'
                  type='button'
                  className='toolbar--button--margin button button--large button--white text-align--center'
                  onClick={() => handleToggleSidebar()}
                >
                  Close
                </button>
              </section>
            </Modal>
          )}
          {(matches.medium || matches.large) && (
            <div className={`${matches.medium ? 'medium-sidebar' : 'large-sidebar'} ${isCollapsed ? 'collapsed' : 'full-width'}`}>
              <div
                className={`toggle-button ${isCollapsed ? 'collapsed' : 'full-width'}`}
                onClick={() => setIsCollapsed(!isCollapsed)}
              >
                <Icon
                  icon='angle-right'
                  className={`icon--font-medium caret-icon ${isCollapsed ? '' : 'rotated'}`}
                  position='none'
                />
              </div>

              {navItems.map(item => (
                <NavItem key={item.id} item={item} isButton={true} />
              ))}
            </div>
          )}
        </>
      )}
    </Media>
  );
};

export default withRouter(NavMenu);
